function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#1b1464",
  stroke: "#1b1464",
  strokeWidth: "0.4px",
  d: "M84.64 5.578L78.857.159A.6.6 0 0 0 78.448 0H66.312A2.246 2.246 0 0 0 64 2.168v21.676a2.246 2.246 0 0 0 2.312 2.168H82.5a2.246 2.246 0 0 0 2.312-2.168V5.961a.525.525 0 0 0-.172-.383zm-.987 18.266a1.123 1.123 0 0 1-1.153 1.083H66.312a1.123 1.123 0 0 1-1.156-1.084V2.168a1.123 1.123 0 0 1 1.156-1.084h11.9l5.444 5.1z",
  transform: "translate(.2 .2) translate(-64)"
}))))), /*#__PURE__*/React.createElement("path", {
  fill: "#d53d53",
  stroke: "#f76c60",
  strokeWidth: "0.1px",
  d: "M128 193.7v10.21a1.72 1.72 0 0 0 1.734 1.7h10.4a1.72 1.72 0 0 0 1.734-1.7V193.7a1.72 1.72 0 0 0-1.734-1.7h-10.4a1.72 1.72 0 0 0-1.734 1.7zm4.046 10.777h-2.312a.573.573 0 0 1-.578-.567v-2.269h2.89v2.836zm4.624 0h-3.47v-2.836h3.468zm4.046-.567a.573.573 0 0 1-.578.567h-2.312v-3.4a.572.572 0 0 0-.578-.567h-8.092v-3.4h11.56v6.807zm-2.89-10.777h2.312a.573.573 0 0 1 .578.567v2.269h-2.89v-2.836zm-4.624 0h3.468v2.836h-3.47zm-1.156 2.836h-2.89V193.7a.573.573 0 0 1 .578-.567h2.312v2.836z",
  transform: "translate(.2 .2) translate(-124.532 -182.89)"
}));

var SvgHCharge = function SvgHCharge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.209,
    height: 26.411,
    viewBox: "0 0 21.209 26.411",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHCharge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/h-charge.a225f639.svg";
export { ForwardRef as ReactComponent };